import * as dayJs from "dayjs";
require("dayjs/locale/en");
require("dayjs/locale/vi");

const localizedFormat = require("dayjs/plugin/localizedFormat");

dayJs.locale("vi");
dayJs.extend(localizedFormat);

export default dayJs;
